import { Injectable } from '@angular/core';
import { ApiService } from '../..';
@Injectable()
export class ThietLapCanhBaoService {

  constructor(public api: ApiService) { }
  APIURL_Chung = "api/ExcuteOracle"
  //Lấy công thức Udm
  public get_Udm() {
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_LAYDS_CONGTHUC_UDM","connstr":"Amiss42"}',
      "para": '{}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lưu công thức Udm
  public save_Udm(tu, udm) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LUU_CONGTHUC_UDM" }),
      para: JSON.stringify({
        v_TU: tu,
        v_UDM: udm,
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lấy công thức Idm
  public get_Idm() {
    var param = {
      "config": '{"namesql":"PKG_CANHBAO.P_LAYDS_CONGTHUC_IDM","connstr":"Amiss42"}',
      "para": '{}'
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lưu công thức Idm
  public save_Idm(ti, idm) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LUU_CONGTHUC_IDM" }),
      para: JSON.stringify({
        v_TI: ti,
        v_IDM: idm,
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lấy list mã cấu hình theo tài khoản
  public get_lst_MaCauHinh(taikhoan) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LAY_MA_CAUHINHCANHBAO" }),
      para: JSON.stringify({
        v_MATAIKHOAN: taikhoan
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lưu Cảnh Báo Mới
  public save_CanhBao(mataikhoan, tencauhinh, U_tren, U_duoi, U_tile, I_tren, I_duoi, Io, cosValue,
    angle_tren, angle_duoi, Pqua_value, SLKODOI_songay, slkytren, slkyduoi, timevalue, ct_udm, ct_idm
    , cb_u, cb_i, cb_cosPhi, cb_goclech, cb_P, cb_sanluong, cb_thoigian, cb_DCU) {

    if (U_tren == "") U_tren = null;
    if (U_duoi == "") U_duoi = null;
    if (U_tile == "") U_tile = null;
    if (I_tren == "") I_tren = null;
    if (I_duoi == "") I_duoi = null;
    if (Io == "") Io = null;
    if (cosValue == "") cosValue = null;
    if (angle_tren == "") angle_tren = null;
    if (angle_duoi == "") angle_duoi = null;
    if (Pqua_value == "") Pqua_value = null;
    if (SLKODOI_songay == "") SLKODOI_songay = null;
    if (slkytren == "") slkytren = null;
    if (slkyduoi == "") slkyduoi = null;
    if (timevalue == "") timevalue = null;
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LUU_CANHBAO" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_TENCAUHINH: tencauhinh,
        v_UTREN: U_tren,
        v_UDUOI: U_duoi,
        v_UTILE: U_tile,
        v_ITREN: I_tren,
        v_IDUOI: I_duoi,
        v_IO: Io,
        v_COSP: cosValue,
        v_ANGELTREN: angle_tren,
        v_ANGELDUOI: angle_duoi,
        v_PQUA: Pqua_value,
        v_SLKODOI_NGAY: SLKODOI_songay,
        v_SLKYTREN: slkytren,
        v_SLKYDUOI: slkyduoi,
        v_TIMEVALUE: timevalue,
        v_CT_UDM: ct_udm,
        v_CT_IDM: ct_idm,
        v_CB_U: cb_u,
        v_CB_I: cb_i,
        v_CB_COSPHI: cb_cosPhi,
        v_CB_GOCLECH: cb_goclech,
        v_CB_P: cb_P,
        v_CB_SANLUONG: cb_sanluong,
        v_CB_THOIGIAN: cb_thoigian,
        v_CB_DCU: cb_DCU,
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lấy danh sách cấu hình cảnh báo
  public get_ALL_CB(mataikhoan, sodong, sotrang) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LAYDS_MAUCAUHINH" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_sotrang: sotrang,
        v_sodong: sodong
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //UPDATE mẫu cấu hình cảnh báo
  public update_CauHinh_CB(mataikhoan, tencauhinh, U_tren, U_duoi, U_tile, I_tren, I_duoi, Io, cosValue,
    angle_tren, angle_duoi, Pqua_value, SLKODOI_songay, slkytren, slkyduoi, timevalue, ct_udm, ct_idm, cb_u,
    cb_i, cb_cosPhi, cb_goclech, cb_P, cb_sanluong, cb_thoigian, cb_dcu, logstr) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_UPDATE_CANHBAO" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_TENCAUHINH: tencauhinh,
        v_U_TREN: U_tren,
        v_U_DUOI: U_duoi,
        v_TILE_UMAX: U_tile,
        v_I_TREN: I_tren,
        v_I_DUOI: I_duoi,
        v_IO: Io,
        v_COS_VALUE: cosValue,
        v_ANGLE_TREN: angle_tren,
        v_ANGLE_DUOI: angle_duoi,
        v_PQUA_VALUE: Pqua_value,
        v_SLKODOI_SONGAY: SLKODOI_songay,
        v_SLKYTREN: slkytren,
        v_SLKYDUOI: slkyduoi,
        v_TIME_VALUE: timevalue,
        v_CT_TINH_UDM: ct_udm,
        v_CT_TINH_IDM: ct_idm,
        v_CB_U: cb_u,
        v_CB_I: cb_i,
        v_CB_COSPHI: cb_cosPhi,
        v_CB_GOCLECH: cb_goclech,
        v_CB_P: cb_P,
        v_CB_SANLUONG: cb_sanluong,
        v_CB_THOIGIAN: cb_thoigian,
        v_CB_DCU: cb_dcu,
        v_LOG_STR: logstr
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Xóa mẫu cấu hình cảnh báo
  public delete_CauHinh_CB(mataikhoan, tencauhinh) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_XOA_MAUCAUHINH" }),
      para: JSON.stringify({
        v_MATAIKHOAN: mataikhoan,
        v_TENCAUHINH: tencauhinh
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lấy danh sách điểm đo
  public getDS_diemdo_theocaythumuc(mataikhoan, danhmucid, loaidiemdo, sodong, sotrang) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LAYDS_DIEMDO_TLCB" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_DANHMUCID: danhmucid,
        v_LOAIDIEMDO: loaidiemdo,
        v_sotrang: sotrang,
        v_sodong: sodong
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lưu thiết lập cảnh báo cho đơn vị
  public save_thietlap_donvi(danhmucid, taikhoan, macanhbao, dskhongchon, type) {
    if (dskhongchon.length == 0) {
      dskhongchon = "";
    }
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LUU_THIETLAP_DONVI" }),
      para: JSON.stringify({
        v_DANHMUCID: danhmucid,
        v_MATAIKHOAN: taikhoan,
        v_MACANHBAO: macanhbao,
        v_DS_DD_KHONGCHON: dskhongchon,
        v_TYPE: type
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lấy chi tiết cấu hình cảnh báo
  public detail_cauhinh_canhbao(macanhbao) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LAY_CHITIET_CANHBAO" }),
      para: JSON.stringify({
        v_MACANHBAO: macanhbao
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Gỡ cấu hình cảnh báo cho từng điểm đo
  public delete_cauhinh_canhbao(mataikhoan, meterid) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_DELETE_CHITIET_CANHBAO" }),
      para: JSON.stringify({
        v_METERID: meterid,
        v_MATAIKHOAN: mataikhoan
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
  //Lưu thiết lập cảnh báo cho danh sách điểm đo
  public save_thietlap_diemdo(danhmucid, taikhoan, macanhbao) {
    var param = {
      config: JSON.stringify({ namesql: "PKG_CANHBAO.P_LUU_THIETLAP_DIEMDO" }),
      para: JSON.stringify({
        v_DS_DIEMDO: danhmucid,
        v_MATAIKHOAN: taikhoan,
        v_MACANHBAO: macanhbao
      })
    };
    return this.api.Excute(this.APIURL_Chung, param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/canh-bao/thiet-lap-canh-bao/thietlapcanhbao.service.ts